import { render, staticRenderFns } from "./AssessmentFarmerIrrigationDetails.vue?vue&type=template&id=8fcf2a12&scoped=true"
import script from "./AssessmentFarmerIrrigationDetails.vue?vue&type=script&lang=js"
export * from "./AssessmentFarmerIrrigationDetails.vue?vue&type=script&lang=js"
import style0 from "./AssessmentFarmerIrrigationDetails.vue?vue&type=style&index=0&id=8fcf2a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcf2a12",
  null
  
)

export default component.exports